module.exports = __webpack_public_path__ + "img/ic-facebook.d86c1e0f.svg";